
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Http, Headers, RequestOptions, ResponseContentType } from "@angular/http";
import { BehaviorSubject, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError, of, empty } from 'rxjs';
import { LoaderService } from './loader.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalVariable } from './global-variable';
import * as moment from 'moment'
import { GlobalData } from './services/globla-data';
import { CookiesService } from './cookies.service';
import { InitialState } from '../store/reducer';
import { Store } from '@ngrx/store';

@Injectable()
export class CommonServiceService {
	employeeConfiguration: any;
	globalSettingConfig: any;
	gstConfiguration: any;
	gstFiledDate: Date;
	dbDateFormat='YYYY-MM-DD';
	dbDateTimeFormat='YYYY-MM-DD HH:mm';

	// public openModalStatus: boolean = false;
	subscription;
	public aws_asset_url = environment.aws_asset_url
	constructor(private httpClient: HttpClient,
		private loaderService : LoaderService,
		private spinner : NgxSpinnerService,
		private cookiesService: CookiesService,
		private store: Store<InitialState>,
		private http : Http) {
		}
		
	public portalConfiguration = [{"crs_id":"WEBSITE","display_name":"AIR ARABIA","url":"https://aadeshtravels.com/api/airarabia/airarabia/v1.0/retrieve/default/","type":"C","scode":"SC000A","acode":"G9514"},{"crs_id":"WEBSITE","display_name":"AIR ARABIA 3L","url":"https://aadeshtravels.com/api/airarabia/airarabia-3l/v1.0/retrieve/default/","type":"C","scode":"SC000A","acode":"G9514"},{"crs_id":"WEBSITE","display_name":"AIRASIA","url":"https://aadeshtravels.com/api/airasia/airasia/v4.0/retrieve/default/","type":"X","scode":"","acode":"AK808"},{"crs_id":"WEBSITE","display_name":"AIRASIA V2","url":"https://aadeshtravels.com/api/air-asia-v2/airasia/v4.0/retrieve/default/","type":"X","scode":"","acode":"AK808"},{"crs_id":"WEBSITE","display_name":"AKASA","url":"https://aadeshtravels.com/api/akasa/akasa/v1.0/retrieve/default/","type":"X","scode":null,"acode":"QP998"},{"crs_id":"WEBSITE","display_name":"AKASA CORPORATE","url":"https://aadeshtravels.com/api/akasa-corporate/akasa/v1.0/retrieve/default/","type":"X","scode":null,"acode":"QP997"},{"crs_id":"WEBSITE","display_name":"ALLIANCE AIR","url":"https://aadeshtravels.com/api/alliance/alliance/v4.0/retrieve/default/","type":"X","scode":null,"acode":"9I198"},{"crs_id":"1A","display_name":"AMADEUS","url":"https://aadeshtravels.com/api/amadeus/amadeus/v4.0/retrieve","type":"B","scode":"799","acode":null},{"crs_id":"1A","display_name":"AMADEUS STUD","url":"https://aadeshtravels.com/api/amadeus-stud/amadeus/v4.0/retrieve/default/","type":"B","scode":"799","acode":null},{"crs_id":"WEBSITE","display_name":"AMADEUS STUD","url":"https://aadeshtravels.com/api/amadeus-stud/amadeus/v4.0/retrieve/default/","type":"B","scode":"799","acode":null},{"crs_id":"1G","display_name":"GALILEO","url":"https://aadeshtravels.com/api/galileo/galileo/v1.0/retrieve/default/","type":"B","scode":"799","acode":null},{"crs_id":"1G","display_name":"GALILEO - RIYA","url":"https://aadeshtravels.com/api/galileo/galileo/v1.0/retrieve/GALILEO - RIYA/","type":"C","scode":"SR000C","acode":null},{"crs_id":"WEBSITE","display_name":"GO","url":"https://aadeshtravels.com/api/go/go/v4.0/retrieve/default/","type":"X","scode":"","acode":"GO008"},{"crs_id":"WEBSITE","display_name":"GO AADESH","url":"https://aadeshtravels.com/api/go-aadesh/go/v4.0/retrieve/default/","type":"X","scode":"","acode":"G8009"},{"crs_id":"WEBSITE","display_name":"GO AMDIHMRA","url":"https://aadeshtravels.com/api/go-amdihmra/go/v4.0/retrieve/default/","type":"X","scode":"ABCDEF","acode":"GO008"},{"crs_id":"WEBSITE","display_name":"GO CORPORATE","url":"https://aadeshtravels.com/api/go-corporate/go/v4.0/retrieve/default/","type":"X","scode":"","acode":"GO008"},{"crs_id":"WEBSITE","display_name":"GO RAJSSERA","url":"https://aadeshtravels.com/api/go-special/go/v4.0/retrieve/default/","type":"X","scode":"ABCDEF","acode":"G8010"},{"crs_id":"WEBSITE","display_name":"GO SPECIAL","url":"https://aadeshtravels.com/api/go-special/go/v4.0/retrieve/default/","type":"X","scode":"ABCDEF","acode":"G8008"},{"crs_id":"WEBSITE","display_name":"GO SRCT","url":"https://aadeshtravels.com/api/go-srct/go/v4.0/retrieve/default/","type":"X","scode":"","acode":"GO008"},{"crs_id":"WEBSITE","display_name":"GO STUD","url":"https://aadeshtravels.com/api/go-stud/go/v4.0/retrieve/default/","type":"X","scode":"","acode":"GO008"},{"crs_id":"WEBSITE","display_name":"INDIGO","url":"https://aadeshtravels.com/api/indigo/indigo/v4.0/retrieve/default/","type":"X","scode":"SS0026","acode":"6E670"},{"crs_id":"WEBSITE","display_name":"INDIGO CORPORATE","url":"https://aadeshtravels.com/api/indigo-corporate/indigo/v4.0/retrieve/default/","type":"X","scode":"SS0026","acode":"6E671"},{"crs_id":"WEBSITE","display_name":"INDIGO-T","url":"https://aadeshtravels.com/api/indigo-t/indigo/v4.0/retrieve/default/","type":"C","scode":"SL0035","acode":"6E674"}, {"crs_id":"WEBSITE","display_name":"INDIGO-COUPON","url":"https://aadeshtravels.com/api/indigo-coupon/indigo/v4.0/retrieve/default/","type":"C","scode":"SL0035","acode":"6E674"},{"crs_id":"WEBSITE","display_name":"indigo-lw","url":"https://aadeshtravels.com/api/indigo-lw/indigo/v4.0/retrieve/default/","type":"X","scode":"SS0026","acode":"7E667"},{"crs_id":"WEBSITE","display_name":"INDIGO OTI114","url":"https://aadeshtravels.com/api/indigo-oti/indigo/v4.0/retrieve/default/","type":"C","scode":"SS0026","acode":"6E675"},{"crs_id":"WEBSITE","display_name":"INDIGO REGULAR KTAMD047","url":"https://aadeshtravels.com/api/indigo/indigo/v4.0/retrieve/KTAMD047/","type":"X","scode":"","acode":"6E671"},{"crs_id":"WEBSITE","display_name":"Indigo SME","url":"https://aadeshtravels.com/api/indigo-corporate/indigo/v4.0/retrieve/default/","type":"X","scode":"SS0026","acode":"6E671"},{"crs_id":"WEBSITE","display_name":"indigo-srct","url":"https://aadeshtravels.com/api/indigo/indigo/v4.0/retrieve/indigo-srct/","type":"X","scode":"SS0027","acode":"6E670"},{"crs_id":"WEBSITE","display_name":"indigo-stud","url":"https://aadeshtravels.com/api/indigo/indigo/v4.0/retrieve/indigo-stud/","type":"X","scode":"","acode":"6E670"},{"crs_id":"1B","display_name":"SABRE","url":"https://aadeshtravels.com/api/sabre/sabre/v1.0/retrieve/default/","type":"B","scode":"799","acode":null},{"crs_id":"WEBSITE","display_name":"SG CORP - B","url":"https://aadeshtravels.com/api/spicejet-corporate/spicejet/v4.0/retrieve/SG CORP/","type":"X","scode":"","acode":"SG051"},{"crs_id":"WEBSITE","display_name":"SG - RAJALB9549","url":"https://aadeshtravels.com/api/spicejet-corporate/spicejet/v4.0/retrieve/RAJALB9549/","type":"X","scode":"","acode":"SG051"},{"crs_id":"WEBSITE","display_name":"SG SRCT","url":"https://aadeshtravels.com/api/spicejet-srct/spicejet/v4.0/retrieve/default/","type":"X","scode":"","acode":"SG050"},{"crs_id":"WEBSITE","display_name":"SG STUD","url":"https://aadeshtravels.com/api/spicejet-stud/spicejet/v4.0/retrieve/default/","type":"X","scode":"","acode":"SG050"},{"crs_id":"WEBSITE","display_name":"SPICEJET","url":"https://aadeshtravels.com/api/spicejet/spicejet/v4.0/retrieve/default/","type":"X","scode":"","acode":"SG050"},{"crs_id":"WEBSITE","display_name":"SPICEJET CORPORATE","url":"https://aadeshtravels.com/api/spicejet-corporate/spicejet/v4.0/retrieve/default/","type":"X","scode":"","acode":"O2020"},{"crs_id":"WEBSITE","display_name":"SPICEJET COUPON","url":"https://aadeshtravels.com/api/spicejet-coupon/spicejet/v4.0/retrieve/default/","type":"X","scode":"","acode":"SG052"},{"crs_id":"WEBSITE","display_name":"SPICEJET - N - S","url":"https://aadeshtravels.com/api/spicejet/spicejet/v4.0/retrieve/SPICEJET - NORMAL - SATI/","type":"C","scode":"SS0026","acode":"SG053"},{"crs_id":"WEBSITE","display_name":"SPICEJET SME","url":"https://aadeshtravels.com/api/spicejet-sme/spicejet/v4.0/retrieve/default/","type":"X","scode":"","acode":"O4040"},{"crs_id":"WEBSITE","display_name":"TRUJET","url":"https://aadeshtravels.com/api/trujet/trujet/v1.0/retrieve/default/","type":"X","scode":"","acode":"2T100"},{"crs_id":"VERTEIL","display_name":"VERTEIL","url":"https://aadeshtravels.com/api/verteil/verteil/v1.0/retrieve/default/","type":"B","scode":null,"acode":"KQ706",},{"crs_id":"VERTEIL","display_name":"VERTEIL-KQ","url":"https://aadeshtravels.com/api/verteil-kq/verteil/v1.0/retrieve/default/","type":"B","scode":null,"acode":"KQ706",}, {"crs_id":"WEBSITE","display_name":"STAR AIR","url":"https://aadeshtravels.com/api/alliance-star/alliance/v4.0/retrieve/default/","type":"X","scode":null,"acode": "S5559"}, {"crs_id":"WEBSITE","display_name":"EK NDC","url":"https://aadeshtravels.com/api/emirates/emirates/v1.0/retrieve/default/","type":"B","scode":null,"acode": "EK176"}]
	public accessLoader = new BehaviorSubject(false);
	accessLoaderStatus = this.accessLoader.asObservable();
	private bookingDetailsSource = new BehaviorSubject([]);
	currentTicket = this.bookingDetailsSource.asObservable()

	public menuLoaded = new BehaviorSubject(false);
	menuLoadedStatus = this.menuLoaded.asObservable();
	
	public setMenuStatus(status){
		this.menuLoaded.next(status)
	}

	private moduleView = new BehaviorSubject(true);
	moduleViewStatus = this.moduleView.asObservable();
	gstData = {
		name : 'b2b',
		data : null
	}
	private typeOfGST = new BehaviorSubject(this.gstData);
	typeOfGSTStatus = this.typeOfGST.asObservable();
	
	private searchModal = new BehaviorSubject('empty');
	searchModalstatus = this.searchModal.asObservable();

	private openLogoutModal = new BehaviorSubject(false);
	openLogoutModalstatus = this.openLogoutModal.asObservable();

	private openSwitchModal = new BehaviorSubject(false);
	openSwitchModalstatus = this.openSwitchModal.asObservable();
	
	
	private searchDropDown = new BehaviorSubject(false);
	searchDropDownstatus = this.searchDropDown.asObservable();
	
	selectedInput: BehaviorSubject<number> = new BehaviorSubject<number>(1);
	selectedSearchInput: BehaviorSubject<number> = new BehaviorSubject<number>(1);

	private logOutSource = new BehaviorSubject(false);
	logOutStatus = this.logOutSource.asObservable();

	advancedSearchSource = new BehaviorSubject(false);
	advancedSearch = this.advancedSearchSource.asObservable();

	toggleTabsSource = new BehaviorSubject(false);
	toggleTab = this.toggleTabsSource.asObservable();


	public toggleTabs(status: boolean) {
		this.toggleTabsSource.next(status)
	}
	public showLogout(status: boolean) {
		this.logOutSource.next(status)
	}

	public setModalStatus(status : boolean){
		this.advancedSearchSource.next(status)
		GlobalVariable.openModalStatus = status;
		console.log('openModalStatus commonservice : ' + GlobalVariable.openModalStatus)
	}

	parseJwt(token) {
		var base64Url = token.split('.')[1];
		var base64 = base64Url.replace('-', '+').replace('_', '/');
		return JSON.parse(window.atob(base64));
	}

	getFinancialSession (strDate = undefined) {
		const date = moment(strDate ? strDate : undefined)
		let month = Number(date.format('MM'))
		let financialSession
		if (month > 3) {
			financialSession = date.format('YYYY')
		} else {
			financialSession = (Number(date.format('YYYY')) - 1)
		}
	
		return financialSession;
	}
	postRequest(url,data) {
		this.spinner.show()
		const headers = new HttpHeaders({
			'Content-Type': 'application/json'
		});
		return this.httpClient.post(url,data,{ headers: headers })
		.pipe(map(res => {
			this.spinner.hide()
			return res;
		}),catchError((err) => {
			this.spinner.hide()
			return throwError(err);
		}))
	}
	postRequestNoloader(url,data) {
		const headers = new HttpHeaders({
			'Content-Type': 'application/json'
		});
		return this.httpClient.post(url,data,{ headers: headers })
		.pipe(map(res => {
			return res;
		}),catchError((err) => {
			return throwError(err);
		}))
	}

	fileUpload(url,data) {
		this.spinner.show()
		let access_token = 	localStorage.getItem("okount_token")
		const headers = new Headers({
			'Authorization': access_token ? access_token : ""
		});
		return this.http.post(url,data, {headers : headers})
		.pipe(map(res => {
			 this.spinner.hide()
			return res;
		}),catchError((err) => {
			 this.spinner.hide()
			return throwError(err);
		}))
	}
	putRequest(url,data) {
		this.spinner.show()
		const headers = new HttpHeaders({
			'Content-Type': 'application/json'
		});
		return this.httpClient.put(url,data,{ headers: headers })
		.pipe(map(res => {
			this.spinner.hide()
			return res;
		}),catchError((err) => {
			this.spinner.hide()
			return throwError(err);
		}))
	}

	patchRequest(url,data) {
		this.spinner.show()
		const headers = new HttpHeaders({
			'Content-Type': 'application/json'
		});
		return this.httpClient.patch(url,data,{ headers: headers })
		.pipe(map(res => {
			this.spinner.hide()
			return res;
		}),catchError((err) => {
			this.spinner.hide()
			return throwError(err);
		}))
	}

	getRequest(url) {
		this.spinner.show()
		const headers = new HttpHeaders({
			'Content-Type': 'application/json'
		});
		return this.httpClient.get(url,{ headers: headers })
		.pipe(map(res => {
			this.spinner.hide()
			return res;
		}),catchError((err) => {
			this.spinner.hide()
			return throwError(err);
		}))
	}
	getRequestNoloader(url) {
		const headers = new HttpHeaders({
			'Content-Type': 'application/json'
		});
		return this.httpClient.get(url,{ headers: headers })
		.pipe(map(res => {
			return res;
		}),catchError((err) => {
			return throwError(err);
		}))
	}

	getRequestWithPdfData(url,queryPrams){
		this.spinner.show()
		const headers = new HttpHeaders({ 
			'Content-Type': 'application/json',
			'Accept' : 'application/pdf'
		  })

		return this.httpClient.get(url,{ headers: headers, params : queryPrams , responseType: 'blob'})
		.pipe(map(res => {
			this.spinner.hide()
			return res;
		}),catchError((err) => {
			this.spinner.hide()
			return throwError(err);
		}))
	}

	getRequestWithQueryParams(url,queryPrams){
		this.spinner.show()
		const headers = new HttpHeaders({
			'Content-Type': 'application/json'
		});
		return this.httpClient.get(url,{ headers: headers, params : queryPrams })
		.pipe(map(res => {
			this.spinner.hide()
			return res;
		}),catchError((err) => {
			this.spinner.hide()
			return throwError(err);
		}))
	}
	getRequestWithQueryParamsNoLoader(url,queryPrams){
		const headers = new HttpHeaders({
			'Content-Type': 'application/json'
		});
		return this.httpClient.get(url,{ headers: headers, params : queryPrams })
		.pipe(map(res => {
			return res;
		}),catchError((err) => {
			return throwError(err);
		}))
	}

	getOkount(url) {
		this.spinner.show()
		// this.toggleLoader(true);
		const headers = new HttpHeaders({
			'Content-Type': 'application/json'
		});
		return this.httpClient.get(`${environment.okountUrl}/${url}`,{ headers: headers})
			.pipe(map(res => {
				this.spinner.hide()
				return res;
			}),
			catchError((err) => {
				this.spinner.hide()
				return throwError(err);
		}))
		
	}
	getOkountNoLoader(url) {
		const headers = new HttpHeaders({
			'Content-Type': 'application/json'
		});
		return this.httpClient.get(`${environment.okountUrl}/${url}`,{ headers: headers})
			.pipe(map(res => {
				return res;
			}),
			catchError((err) => {
				return throwError(err);
		}))
	}
	
	postWithOutInterceptor(url,data,withLoader=true) {
		if(withLoader) this.spinner.show()
		
		// this.toggleLoader(true);
		const headers = new HttpHeaders({
			'Content-Type': 'application/json'
		});
		return this.http.post(url,data)
			.pipe(map(res => {
				if(withLoader) this.spinner.hide()
				return res;
			}),
			catchError((err) => {
				if(withLoader) this.spinner.hide()
				return throwError(err);
		}))
		
	}

	getWithOutInterceptor(url) {
		this.spinner.show()
		// this.toggleLoader(true);
		const headers = new HttpHeaders({
			'Content-Type': 'application/json'
		});
		return this.http.get(url)
			.pipe(map(res => {
				this.spinner.hide()
				return res;
			}),
			catchError((err) => {
				this.spinner.hide()
				return throwError(err);
		}))
		
	}

	deleteRequest(url) {
		this.spinner.show()
		return this.httpClient.delete(url)
		.pipe(map(res => {
			this.spinner.hide()
			return res;
		}),catchError((err) => {
			this.spinner.hide()
			return throwError(err);
		}))
	}


	deleteRequestWithBodyParam(url,data) {
		this.spinner.show()
		const httpOptions = {
			headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: data
		};
		
		return this.httpClient.delete(url,httpOptions)
		.pipe(map(res => {
			this.spinner.hide()
			return res;
		}),catchError((err) => {
			this.spinner.hide()
			return throwError(err);
		}))
	}


	generatePDF(data){
		this.spinner.show()
	   let headers = new Headers({ 
		   'Content-Type': 'application/json', 
		   'Accept' : 'application/pdf'
		});
		let options = new RequestOptions({ headers: headers });
	   // Ensure you set the responseType to Blob.
	   options.responseType = ResponseContentType.Blob;
	   return this.http.post(`${environment.pdfGeneratorUrl}`, data, options)
		   .pipe(map(res => {
			this.spinner.hide()
			   return res;
		   }),
		   catchError((err) => {
			this.spinner.hide()
			   return throwError(err);
		   }))
   }

   downloadPDF(url, queryParams=null){
		this.spinner.show()
		
	
		const headers = new HttpHeaders({ 
			'Content-Type': 'application/json',
			'Accept' : 'application/pdf'
		  })
	
		
		return this.httpClient.get(url , {headers: headers, params: queryParams, responseType: 'blob' })
			.pipe(map(res => {
				this.spinner.hide()
				return res;
			}),
			catchError((err) => {
				this.spinner.hide()	
				return throwError(err);
			}))
	}

	downloadAllPDF(url, data=null){
		this.spinner.show()
	  
		const headers = new HttpHeaders({ 
			'Content-Type': 'application/json',
			'Accept' : 'application/pdf'
		})

		return this.httpClient.post(url, data, {headers: headers, responseType: 'blob' })
		   .pipe(map(res => {
			this.spinner.hide()
			   return res;
		   }),
		   catchError((err) => {
			this.spinner.hide()
			   return throwError(err);
		   }))
	}

	minimizeModule(status: boolean) {       
        this.moduleView.next(status)
	}
	showGstPage(name){
		this.typeOfGST.next(name)
	}
	setSearchModal(name){
		this.searchModal.next(name)
	}

	setLogOutModalStatus(status){
		this.openLogoutModal.next(status)
	}
	setSwitchModalStatus(status){
		this.openSwitchModal.next(status)
	}

	setDropDownStatus(status){
		this.searchDropDown.next(status)
	}

	generateRandomText (length) {
		var result = '';
		var characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
		var charactersLength = characters.length;
		for (var i = 0; i < length; i++) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
		}
		return result;
	}
	generateRandomNumber (length) {
		var result = '';
		var characters = '0123456789';
		var charactersLength = characters.length;
		for (var i = 0; i < length; i++) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
		}
		return Number(result);
	}

	getConfiguration(account_code){
		return new Promise((resolve, reject) => {
			this.getRequest(`${environment.okountUrl}/master_settings?account_code=${account_code}`).subscribe((res: any) => {
				if(res && res.length > 0){
					this.employeeConfiguration = res[0].json_doc['value']
				}else{
					this.getRequest(`${environment.okountUrl}/global_settings?group=EMPLOYEE`).subscribe((res: any) => {
						if(res && res.length > 0){
							this.employeeConfiguration = res[0].json_doc['value']
						}else{
							this.employeeConfiguration = []
						}
					})
				}
				resolve(this.employeeConfiguration)
			},err=> {
				this.employeeConfiguration = []
				resolve(this.employeeConfiguration)
			})
		})
	}

	getClientConfiguration(account_code){
		return new Promise((resolve, reject) => {
			this.getRequest(`${environment.okountUrl}/master_settings?account_code=${account_code}`).subscribe((res: any) => {
				if(res && res.length > 0){
					resolve(res[0].json_doc['value'])
				} else {
					resolve([])
				}
			},err=> {
				resolve([])
			})
		})
	}

	getConfigurationByKey(key){
		let data =  this.employeeConfiguration.filter(data=> data.key == key)
		if(data && data.length > 0){
			return data[0]
		}else{
			return null
		}
	}

	getFeatureData(roleId: any) {
		return new Promise(async (resolve, reject) => {
			// if(this.subscription && this.subscription.unsubscribe){
			// 	this.subscription.unsubscribe()
			// }
			this.subscription = this.getRequestNoloader(`${environment.okountUrl}/featureaccess/role?id=${roleId}`).subscribe(res=>{
				localStorage.setItem('accessData',JSON.stringify(res))
				GlobalData.setAccessData(res);
				this.setMenuStatus(true)
				resolve(res);
			}, error =>{
				localStorage.removeItem('accessData')
				GlobalData.setAccessData(null);
				resolve(null);
			})
		})
	}

	getGlobalSettings() {
		return new Promise((resolve, reject) => {
			this.getRequest(`${environment.okountUrl}/global_settings`).subscribe((res: any) => {
				if(res) {
					this.globalSettingConfig = res;
					let gst = res.find(item => item.group == 'GST')
					let gstValue = gst && gst.json_doc && gst.json_doc.value;
					let gstFiledItem = gstValue.find(item => item.key == 'last_gst_filed_date')
					if(gstFiledItem) {
						let gstFiledValue  = gstFiledItem.value;
						if(gstFiledValue) {
							let item = gstFiledValue[0]
							this.gstFiledDate = item.value;
						}
					}
					try {
						let transaction_config = this.globalSettingConfig.filter(el=>el.group=='TRANSACTION');
						let date_formatting_config = transaction_config[0].json_doc["value"].filter(el=>el.key=='date_formatting')
						if(date_formatting_config && date_formatting_config.length){
							localStorage.setItem('date_formatting',JSON.stringify(date_formatting_config[0].value))
						}
					} catch (error) {
						
					}
				}else {
					this.globalSettingConfig = [];
				}
				resolve(this.globalSettingConfig)
			}, err => {
				this.globalSettingConfig = []
				resolve(this.globalSettingConfig)
			})
			
		})

	}
	/**
	 * 
	 * @param format_key | date_format, date_time_format
	 * @returns { dateFormat, isLocaleDateFormat}
	 */
	getDateFormat(format_key = 'date_format'){
		let dateFormat;
		let isLocaleDateFormat = true;
		try {
			let dateFormatConfig = localStorage.getItem('date_formatting') ? JSON.parse(localStorage.getItem('date_formatting')) : null
			if(!dateFormatConfig){
				let transaction_config = this.globalSettingConfig.filter(el=>el.group=='TRANSACTION');
				let date_formatting_config = transaction_config[0].json_doc["value"].filter(el=>el.key=='date_formatting')
				if(date_formatting_config && date_formatting_config.length){
					dateFormatConfig = date_formatting_config[0].value
					localStorage.setItem('date_formatting',JSON.stringify(dateFormatConfig))
				}
			}
			let dateConfig = dateFormatConfig.filter(el=>el.key==format_key)
			if(dateConfig[0].value != 'locale_date' && moment().format(dateConfig[0].value) !== 'Invalid Date'){
				dateFormat  = dateConfig[0].value
				isLocaleDateFormat = false
			}else{
				isLocaleDateFormat = true
			}
			return { dateFormat, isLocaleDateFormat}
		} catch (error) {
			return { dateFormat, isLocaleDateFormat}
		}
	}
	checkTenantIndian(){
		if(this.cookiesService.getCookie('SYSTACC_USER_LOGIN_DATA')) {
			let userData = JSON.parse(this.cookiesService.getCookie('SYSTACC_USER_LOGIN_DATA'))
			if(userData.t_tenant_info && userData.t_tenant_info.tenant_region_type && userData.t_tenant_info.tenant_region_type == 'INDIAN') {
				return true;
			}else{
				return false
			}
		}
	}

	async checkHQBranch(){
		let tenant_data = this.cookiesService.getCookie('SYSTACC_USER_LOGIN_DATA')
		if(tenant_data){
		  tenant_data = JSON.parse(tenant_data)
		  if(tenant_data && tenant_data['t_tenant_info'] && tenant_data['t_tenant_info']['branch_type'] && tenant_data['t_tenant_info']['branch_type'] == 'HQ'){
			if(!this.globalSettingConfig || this.globalSettingConfig.length==0) await this.getGlobalSettings();
			let transaction_config = this.globalSettingConfig.filter(el=>el.group=='TRANSACTION');
			let hq_detail  = 'false'
			if(transaction_config.length){
				let vat_config = transaction_config[0].json_doc.value.filter(el=>el.key=='Individual Branches')
				if(vat_config.length){
					hq_detail = vat_config[0].value
				}

			}
			return hq_detail=='false'?true:false;
			}else{
				return false
			}
		}
	}

	checkHQCompany(){
		let tenant_data = this.cookiesService.getCookie('SYSTACC_USER_LOGIN_DATA')
		if(tenant_data){
		  tenant_data = JSON.parse(tenant_data)
		  if((tenant_data && tenant_data['t_tenant_info'] && !tenant_data['t_tenant_info']['associate_company_id']) ||( tenant_data['t_tenant_info']['associate_company_id'] == null)){
			return true;
			}else{
				return false
			}
		}
	}

	checkTesoyBoult(){
		let tenant_data = this.cookiesService.getCookie('SYSTACC_USER_LOGIN_DATA')
		if(tenant_data){
			 let userData = JSON.parse(tenant_data)
		  if(userData.tenant_id && environment.BHUPESH_TENANT.split(',').includes(typeof userData.tenant_id=='number'?userData.tenant_id.toString():userData.tenant_id)){
				return true;
			}else{
				return false
			}
		}
	}
	

	checkCreditNoteNonRefundableOrNot() {
		if(this.globalSettingConfig && this.globalSettingConfig.length>0) {
			let nonRefundableGroup = this.globalSettingConfig.find(item => item.group == 'NON REFUNDABLE CRN');
			let nonRefundableGroupJsonDoc = nonRefundableGroup && nonRefundableGroup.json_doc;
			if(nonRefundableGroupJsonDoc) {
				let value = nonRefundableGroupJsonDoc.value
				if(value) {
					let object = value.find(item => item.key == 'non_refundable')
					if(object) {
						if(object.value && object.value == "true") {
							return true
						} else {
							return false
						}
					}
				}
			} else {
				return false;
			}
        }
	}

	isP2PEnabled() {
		if(this.globalSettingConfig && this.globalSettingConfig.length>0) {
			let p2pData = this.globalSettingConfig.find(item => item.group == 'DISPLAY_P2P');
			let displayP2PJsonDoc = p2pData && p2pData.json_doc;
			if(displayP2PJsonDoc) {
				let value = displayP2PJsonDoc.value
				if(value) {
					let object = value.find(item => item.key == 'Enable')
					if(object) {
						if(object.value && object.value == "TRUE") {
							return true
						} else {
							return false
						}
					}
				}
			} else {
				return false;
			}
        }
	}

	getCurrentFinancialYear() {
		let current_financial_year =  JSON.parse(sessionStorage.getItem('current_financial_year'))
        if(!current_financial_year) {
            current_financial_year = JSON.parse(localStorage.getItem('current_financial_year'));
        }
		return current_financial_year;
	}

	checkFinancialYearDifferent() {
		let isFinancialYearDiff = false;
		let current_financial_year = this.getCurrentFinancialYear();
		
		let financial_year = Number(moment().format('YYYY'));
    	let financial_month = Number(moment().format('MM'));
    	if (financial_month < 4) financial_year -= 1;
		let current_start_date = Number(moment(current_financial_year.start_date,"YYYY-MM-DD").format("YYYY"))
		
		if(current_start_date != financial_year) {
			isFinancialYearDiff = true;
		}
		return {
			isFinancialYearDiff : isFinancialYearDiff,
			current_financial_year : current_financial_year
		};
	}

	checkFinancialYearValidation() {
		let minDate = '';
		let maxDate = '';

		let fnYearResp = this.checkFinancialYearDifferent();

		this.store.select('sharedReducers').subscribe((items)=>{
			if(items.financeYear && items.financeYear.start_date && items.financeYear.end_date){
				minDate = items.financeYear.start_date;
				maxDate = this.getFinancialSession(moment(items.financeYear.end_date)) < this.getFinancialSession(moment()) ? 
						moment(items.financeYear.end_date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
			} else {
				minDate = fnYearResp.current_financial_year.start_date;
				maxDate = this.getFinancialSession(moment(fnYearResp.current_financial_year.end_date)) < this.getFinancialSession(moment()) ? 
						moment(fnYearResp.current_financial_year.end_date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
			}
		})

		return {
			isFinancialYearDiff : fnYearResp.isFinancialYearDiff,
			minDate : minDate,
			maxDate : maxDate
		};
	}

}
